import { selectors as assetsSelectors } from '@mulesoft/exchange-ui-portals-store/lib/domains/assets';
import { selectors as pagesSelectors } from '@mulesoft/exchange-ui-portals-store/lib/domains/pages';

export function redirectIfDefaultPageEmpty({
  basePath,
  typeDefinition,
  pushFn,
  assetParams
}) {
  return (dispatch, getState) => {
    const state = getState();
    const path = typeDefinition?.routes?.find(
      (route) => route.defaultOnEmptyHome
    )?.path;

    const page = pagesSelectors.page(state, assetParams);
    const asset = assetsSelectors.asset(state, assetParams);

    const isAssetHomeEmpty = page.html === '';

    const canEditAsset = asset.permissions?.find((permission) =>
      ['edit', 'admin'].includes(permission)
    );

    if (path && isAssetHomeEmpty && !canEditAsset) {
      const targetPath = `${basePath}${path}`;

      pushFn(targetPath);
    }
  };
}
